export default __webpack_public_path__ + "static/media/cafe_front.280a1b8c.png";